export function useIsTruncated({ elementRef, content }) {
  const isTruncated = ref(false);

  const { width, height } = useElementSize(elementRef);

  const updateIsTruncated = async() => {
    await nextTick();

    const el = elementRef.value;
    if (el) {
      isTruncated.value = el.scrollHeight > el.offsetHeight;
    }
  };

  watch([elementRef, content, width, height], updateIsTruncated);

  return isTruncated;
};
